import React, { Component } from "react";
import { Col, Container, Row } from 'reactstrap';
import { withRouter, } from "react-router-dom";
import ModalsVentasPage from "./modals.ventas.page";
import Select from 'react-select'
import moment from 'moment'
import TimeAgo from 'react-timeago'
import spanishStrings from 'react-timeago/lib/language-strings/es'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'

const customStylesOption = { control: styles => ({ ...styles, backgroundColor: '#fff', width: '90%', margin: '0 auto', marginBottom: 20, }), }
const customStyles = { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '70%',height: '70%',} };
const formatter = buildFormatter(spanishStrings)

class AltasModulePage extends Component {
  constructor(props) {
    super(props);
    this.keyBindingBtns = this.keyBindingBtns.bind(this);
    this._handleKeyDown = this._handleKeyDown.bind(this)

    this.state = {
      mostrarMisVentas: false,
      arrStock: [],
      arrStockMeta: [],
      dateAlmacen: moment().format('YYYY-MM-DD'),

      valSearch: '',
      valSearchByFullCode: '',
      indexItemByKeyboard: -1,
      isOpenSearchProducto: false,
      valSeach: '',

      indexTraspasoView: -1,

      viewTypeFrom: 'general', //or meta

      arrSucursalesAraceli: [
        {id_sucursal: '5f2071cb0ww32', nombre: 'RUTA', label: 'RUTA', value: 'RUTA', },
        {id_sucursal: 'almacen_gral', nombre: 'ALMACEN GRAL', label: 'ALMACEN GRAL', value: 'ALMACEN GRAL', },
      ],
      id_sucursal_destino: '',


    }
  }

  componentDidMount() {
    this.getStockAlmacen()
    document.addEventListener("keydown", this.keyBindingBtns, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keyBindingBtns, false);
  }

  keyBindingBtns(event) {
    const { indexItemByKeyboard, arrayListResults, isOpenSearchProducto, isOpenPagarCompra, } = this.props.subState
    const { renderView } = this.props.initState

    if(renderView !== 'altas')
      return false
    // [productos] F2  -> 113
    // [abajo]     ⬇  -> 40
    // [arriba]    ⬆  -> 38
    // [enter]     ⤵  -> 13

    if(event.keyCode === 113) {

      this.setBindProductos()
    } else if(event.keyCode === 40) {

      if(isOpenSearchProducto)
        this.props.subSetState({ indexItemByKeyboard: indexItemByKeyboard < (arrayListResults.length - 1) ? (indexItemByKeyboard + 1) : indexItemByKeyboard })
    } else if(event.keyCode === 38) {

      if(isOpenSearchProducto)
        this.props.subSetState({ indexItemByKeyboard: indexItemByKeyboard > 0 ? (indexItemByKeyboard - 1) : indexItemByKeyboard })
    } else if(event.keyCode === 13) {
      
      if(isOpenSearchProducto && arrayListResults.length > 0) {
        this.selectItemProduct(indexItemByKeyboard)
        this.props.subSetState({ indexItemByKeyboard: 0, })
      } else if(isOpenPagarCompra) {
        // this.onRegisterNewVenta()
      }
    } else if(event.keyCode === 9) {
      if( document.activeElement.id === 'ws-input-search-code' ) {
        this.onSearchProductoByCode()
        event.preventDefault()
      }
    }
  }


  render() {
    const { mostrarMisVentas } = this.state

    return (
      <div style={{ padding: 10, background: '#fff', margin: 0, }}>
        <Row>
          {/*<Col>
            <p
              className={'altasModule__btnAction'}
              onClick={() =>{ this.props.subSetState({ isOpenAltaProductos: true, }) }}
            >Registrar nuevo producto</p>
          </Col>*/}
          <Col>
            <p
              className={'altasModule__btnAction'}
              onClick={() =>{ this.setState({ mostrarMisVentas: !mostrarMisVentas }) }}
            >{mostrarMisVentas ? 'Ver mi almacén' : 'Registrar entrada al almacén'}</p>
          </Col>
          <Col>
            <p
              className={'altasModule__btnAction'}
              onClick={() =>{ this.props.subSetState({ isOpenHistoryEntradaAlmacen: true, }); this.getHistoryEntradas() }}
            >Ver historial de entradas</p>
          </Col>
          <Col>
            <p
              className={'altasModule__btnAction'}
              onClick={() =>{ window.open('https://hg.wsoft.com.mx/inventariosgeneral?tkn=wso', '_blank') }}
            >Ver inventario general (stock)</p>
          </Col>
        </Row>
        
        { mostrarMisVentas ? this.makeViewAlmacen() : this.makeViewVentas() }
        
        <ModalsVentasPage
          subState={ this.props.subState } subSetState={ (param) => this.props.subSetState(param) }
          initState={ this.props.initState } initsetState={ (param) => this.props.initsetState(param) }
          selectItemProduct={ (e) => this.selectItemProduct(e) }
        />
      </div>
    )
  }

  getHistoryEntradas() {
    const { id_vendedor, id_sucursal, } = this.props.initState

    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getHistoryEntradas", this.headersPOST({ id_vendedor, id_sucursal, }))
    .then(response => response.json())
    .then((response) => {
      this.props.subSetState({ arrHistoryEntradaAlmacen: {index: -1, list: response.list, productos: [], }, })
    })
  }

  makeViewAlmacen() {
    const { fecha_entrada_almacen, serie_almacen, referencia_almacen, noDocEntradaAlmacen, } = this.props.subState
    const { signedIn, } = this.props.initState
    const { arrSucursalesAraceli, } = this.state

    return (
      <div className="initialPage__wrapper"  style={{ backgroundColor: 'transparent', }}>
        {/* Principal Container */}
        <Row style={{ width: '99%', margin: '0 auto' }}>
          <Col className={'z-depth-1'} style={{ background: '#fff', }}>
            
            <Row>
              <p className="regVentaPage__product" style={{ padding: '0 15px', fontWeight: '400', marginBottom: 10, color: '#444', textAlign: 'center', width: '100%', }}>Entrada al almacén</p>
              <hr />
            </Row>

            <Row>
              <Col>
                <Row>
                  <Col>
                    <p className="regVentaPage__product" style={{ padding: 0, }}>Fecha</p>
                  </Col>
                  <Col xs={'7'}>
                    <input type={"date"}
                      value={fecha_entrada_almacen}
                      onChange={(event) => {this.props.subSetState({fecha_entrada_almacen: event.target.value}) }}
                      style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                    />
                  </Col>
                </Row>

                <Row>
                  <p className="regVentaPage__product" style={{ padding: '0 15px', width: '100%', }}>Documento #{noDocEntradaAlmacen}</p>
                </Row>

                {

                  /* ONLY ARACELI USER: */
                  signedIn.type === 5 ? (
                    <Row>
                      <Col>
                        <p className="regVentaPage__product" style={{ padding: 0, }}>Sucursal de destino</p>
                      </Col>
                      <Col xs={'7'}>
                        <Select
                          placeholder="ELIGE UNA SUCURSAL"
                          options={arrSucursalesAraceli}
                          onChange={(val) => { this.setState({ id_sucursal_destino: val.id_sucursal, }) }}
                          styles={customStylesOption}
                        />
                      </Col>
                    </Row>
                  ) : null
                }

              </Col>

              <Col>
                <Row>
                  <Col>
                    <p className="regVentaPage__product" style={{ padding: 0, }}>Serie</p>
                  </Col>
                  <Col xs={'7'}>
                    <input type={'text'}
                      placeholder={'Ingresa una serie'}
                      value={serie_almacen}
                      onChange={ (event) => { this.props.subSetState({serie_almacen: event.target.value}) }}
                      style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p className="regVentaPage__product" style={{ padding: 0, }}>Referencia</p>
                  </Col>
                  <Col xs={'7'}>
                    <input type={'text'}
                      placeholder={'Ingresa una referencia'}
                      value={referencia_almacen}
                      onChange={ (event) => { this.props.subSetState({referencia_almacen: event.target.value}) }}
                      style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <hr />

            <Row>
              <Col xs={'2'}>
                <b>Código</b>
              </Col>
              <Col xs={'3'}>
                <b>Nombre</b>
              </Col>
              <Col xs={'2'}>
                <b>Cantidad</b>
              </Col>
              <Col xs={'2'}>
                <b>Cortesía</b>
              </Col>
              <Col xs={'1'}>
                <b>Costo</b>
              </Col>
              <Col xs={'1'}>
                <b>Total</b>
              </Col>
              <Col xs={'1'}>
                <b>Opciones</b>
              </Col>
            </Row>

            <hr />

            { this.makeItemsEntradasAlmacen() }

          </Col>

        </Row>

      </div>

    )
  }

  makeViewVentas() {
    let { arrStock, arrStockMeta, valSeach, indexTraspasoView, } = this.state
    let { arrTraspasosPendientes, } = this.props.subState
    const { signedIn, } = this.props.initState
    valSeach = valSeach.trim()

    return (
      <div className="initialPage__wrapper"  style={{ backgroundColor: 'transparent', }}>
        {/* Principal Container */}
        <Row style={{ width: '99%', margin: '0 auto' }}>
          <Col className={'z-depth-1'} style={{ background: '#fff', }}>

            <hr />
            <Row>
              <p className="regVentaPage__product" style={{ padding: '0 15px', fontWeight: '400', marginBottom: 10, color: '#444', textAlign: 'center', width: '100%', }}>Mi almacén</p>
            </Row>
            <hr />
            
            {
              signedIn.type !== 2 ? (
                <>
                  <input
                    type={'date'}
                    value={ this.state.dateAlmacen }
                    onChange={(e) => { this.setState({ dateAlmacen: e.target.value }) }}
                  />
                  <br />
                  <p className={'btn btn-primary'} onClick={() => { this.getStockAlmacen() }}>Generar</p>
                  <p className={'btn btn-primary'} onClick={() => { this.setState({ viewTypeFrom: (this.state.viewTypeFrom === 'meta' ? 'general' : 'meta') }, this.getStockAlmacen) }}>Cambiar vista</p>
                  <hr />
                  {
                    arrStock.length > 0 && arrStock.map((t,e) => (
                      <>
                      {
                        t.list.length > 0 ? (
                          <div className={'ws__list_categorias_almacen'}>
                            <Row className={`ws__list_categorias_almacen_p ${t.show ? 'active' : ''}`} onClick={() => { this.onExpandSectionCate(t,e) }}>
                              <Col>
                                <p>{t.nombre}</p>
                              </Col>
                              <Col>
                                <p style={{ fontSize: '.8rem', textAlign: 'right', }}>({this.number_format(t.list.length, 0)}) productos</p>
                              </Col>
                            </Row>

                            {
                              t.show ? (
                                <div className={'ws__searchcnt'}>
                                  <p>Buscar</p>
                                  <input
                                    type={'text'}
                                    value={valSeach}
                                    onChange={ (event) => { this.setState({ valSeach: event.target.value }) } }
                                    placeholder={'Buscar un producto...'}
                                  />
                                </div>
                              ) : null
                            }
                            {
                              t.show ? (
                              <Row>
                                <Col xs={'4'}>
                                  <b>Nombre</b>
                                </Col>
                                <Col xs={'2'}>
                                  <b>Existencia</b>
                                </Col>
                                {/*<Col xs={'1'}>
                                  <b>Cantidad en pesos</b>
                                </Col>*/}
                                <Col xs={'2'}>
                                  <b>Entrada del día</b>
                                </Col>
                                <Col xs={'1'}>
                                  <b>Merma</b>
                                </Col>
                                <Col xs={'1'}>
                                  <b>Traspaso</b>
                                </Col>
                                <Col xs={'2'}>
                                  <b>Vendida</b>
                                </Col>
                              </Row>
                              ) : null
                            }

                            {
                              t.show && t.list.map((t0,e0) => (
                                <>
                                {
                                  valSeach === '' || 
                                  t0.clave.toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ||
                                  t0.nombre.trim().toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ? (
                                  <Row className={'ventasPage__listProductos ws__list_categorias_almacen_child'} style={{ marginTop: 20, marginBottom: 20, }}>
                                    <Col xs={'4'}>
                                      <p>{t0.nombre}</p>
                                      <p>{t0.clave}</p>
                                    </Col>
                                    <Col xs={'2'}>
                                      <p>{this.number_format(t0.disponible, 2)}</p>
                                    </Col>
                                    {/*
                                    <Col xs={'1'}>
                                      <p>${this.number_format((t0.disponible * t0.precio_compra), 2)}</p>
                                    </Col>
                                    */}
                                    <Col xs={'2'}>
                                      <p>{this.number_format(t0.cantidad_dia, 2)}</p>
                                    </Col>
                                    <Col xs={'1'}>
                                      <p>{this.number_format(t0.cantidad_merma, 2)}</p>
                                    </Col>
                                    <Col xs={'1'}>
                                      <p>{this.number_format(t0.cantidad_traspaso, 2)}</p>
                                    </Col>
                                    <Col xs={'2'}>
                                      <p>{t0.cantidad_vendida}</p>
                                    </Col>
                                  </Row>
                                  ) : null
                                }
                                </>
                              ))
                            }

                          </div>
                        ) : null
                      }
                      </>
                    ))
                  }

                  {
                    arrStockMeta.length > 0 && arrStockMeta.map((t,e) => (
                      <>
                      {
                        t.list.length > 0 ? (
                          <div className={'ws__list_categorias_almacen'}>
                            <Row className={`ws__list_categorias_almacen_p ${t.show ? 'active' : ''}`} onClick={() => { this.onExpandSectionCateMeta(t,e) }}>
                              <Col>
                                <p>{t.nombre}</p>
                              </Col>
                              <Col>
                                <p style={{ fontSize: '.8rem', textAlign: 'right', }}>({this.number_format(t.list.length, 0)}) productos</p>
                              </Col>
                            </Row>

                            {
                              t.show ? (
                                <div className={'ws__searchcnt'}>
                                  <p>Buscar</p>
                                  <input
                                    type={'text'}
                                    value={valSeach}
                                    onChange={ (event) => { this.setState({ valSeach: event.target.value }) } }
                                    placeholder={'Buscar un producto...'}
                                  />
                                </div>
                              ) : null
                            }
                            {
                              t.show ? (
                              <Row>
                                <Col xs={'6'}>
                                  <b>Nombre</b>
                                </Col>
                                <Col xs={'2'}>
                                  <b>Mes año anterior</b>
                                </Col>
                                <Col xs={'2'}>
                                  <b>Mes año actual</b>
                                </Col>
                                <Col xs={'2'}>
                                  <b>Progreso</b>
                                </Col>
                              </Row>
                              ) : null
                            }

                            {
                              t.show && t.list.map((t0,e0) => (
                                <>
                                {
                                  valSeach === '' || 
                                  t0.clave.toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ||
                                  t0.nombre.trim().toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ? (
                                  <Row className={'ventasPage__listProductos ws__list_categorias_almacen_child'} style={{ marginTop: 20, marginBottom: 20, }}>
                                    <Col xs={'6'}>
                                      <p>{t0.nombre}</p>
                                      <p>{t0.clave}</p>
                                    </Col>
                                    <Col xs={'2'}>
                                      <p>{(t0.kg_before)}</p>
                                    </Col>
                                    <Col xs={'2'}>
                                      <p>{(t0.kg_current)}</p>
                                    </Col>
                                    <Col xs={'2'}>
                                      <p>{this.number_format((t0.kg_current / t0.kg_before) * 100, 2)}%</p>
                                    </Col>
                                  </Row>
                                  ) : null
                                }
                                </>
                              ))
                            }

                          </div>
                        ) : null
                      }
                      </>
                    ))
                  }
                </>
              ) : (<p>No tienes permisos suficientes para visualizar este almacén.</p>)
            }


          </Col>

        </Row>

      </div>

    )
  }

  onExpandInfoTraspasoProducto(e) {
    let { arrTraspasosPendientes, } = this.props.subState
    this.setState({ indexTraspasoView: e, })

    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getProductosByTraspasoGral", this.headersPOST({ id_entrada: arrTraspasosPendientes[e].id_entrada }))
    .then(response => response.json())
    .then((response) => {
      arrTraspasosPendientes[e].arrListProductos = response.list
      this.props.subSetState({ arrTraspasosPendientes })
    })
  }

  setFinalizaTraspasoSuc() {
    let { indexTraspasoView, } = this.state
    let { arrTraspasosPendientes, } = this.props.subState
    const { id_vendedor, id_sucursal, } = this.props.initState

    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setFinalizaTraspasoSuc", this.headersPOST({ id_sucursal, id_vendedor, ...arrTraspasosPendientes[indexTraspasoView], }))
    .then(response => response.json())
    .then((response) => {
      alert('Traspaso confirmado con éxito.')
      this.setState({
        indexTraspasoView: -1,
      })
      setTimeout(() => {
        this.props.initState.socket.emit("toCajero", { client: 'hgapp', substrace: 'setUpdateEntradasAlmacen', })
      }, 1000)

    })
  }

  onExpandSectionCate(t,e) {
    let { arrStock, } = this.state
    for(var a in arrStock) {
      if(a != e)
        arrStock[a].show = false
      else
      arrStock[a].show = !arrStock[a].show
    }
    this.setState({ arrStock, valSeach: '', })
  }

  onExpandSectionCateMeta(t,e) {
    let { arrStockMeta, } = this.state
    for(var a in arrStockMeta) {
      if(a != e)
        arrStockMeta[a].show = false
      else
      arrStockMeta[a].show = !arrStockMeta[a].show
    }
    this.setState({ arrStockMeta, valSeach: '', })
  }

  makeItemsEntradasAlmacen() {
    const { arrItemsAlmacen, arrayListProductos, } = this.props.subState
    const { id_sucursal_destino, } = this.state
    let cantidadTotal = 0
    arrItemsAlmacen.map((t) => { cantidadTotal += ( t.costo * t.cantidad )})

    //Show item new
    return (

      <>
        {
          arrItemsAlmacen.map((t,e) => (
            <Row>
              <Col xs={'2'}>
                <b>{t.codigo}</b>
              </Col>
              <Col xs={'3'}>
                <b>{t.producto}</b>
              </Col>
              <Col xs={'2'}>
                <input
                  ref={input => {
                    this[`inputAlmacenNew${e}`] = input;
                  }}
                  type={'text'}
                  onChange={ (event) => {
                    arrItemsAlmacen[e].cantidad = event.target.value;
                    this.props.subSetState({ arrItemsAlmacen });
                  }}
                  value={ t.cantidad }
                  placeholder={'Ingresa la cantidad'}
                  style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                />
                {
                  id_sucursal_destino === 'almacen_gral' && parseFloat(t.cantidad) < 0
                  ? <span>Al realizar una entrada en negativo se tomará como descuento de un proceso primario o producto para ser incrementado en otro.</span>
                  : null
                }
              </Col>
              <Col xs={'2'}>
                <input
                  type={'text'}
                  onChange={ (event) => {
                    arrItemsAlmacen[e].cortesia = event.target.value;
                    this.props.subSetState({ arrItemsAlmacen });
                  }}
                  value={ t.cortesia }
                  placeholder={'Ingresa la cortesía'}
                  style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                />
              </Col>
              <Col xs={'1'}>
                <input type={'text'}
                  onChange={ (event) => {
                    arrItemsAlmacen[e].costo = event.target.value;
                    this.props.subSetState({ arrItemsAlmacen });
                  }}
                  value={ t.costo }
                  placeholder={'Ingresa el costo'}
                  style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                />
              </Col>
              <Col xs={'1'}>
                <p> ${ this.number_format((t.cantidad * t.costo), 2) } </p>
              </Col>
              <Col xs={'1'}>
                <p
                  style={{ cursor: 'pointer', color: 'red', fontWeight: '800', }}
                  onClick={() => {
                    const arr = arrItemsAlmacen.filter(function(item, index) { return index !== e })
                    this.props.subSetState({ arrItemsAlmacen: arr })
                  }}
                >X</p>
              </Col>
            </Row>
          ))
        }

        {
          arrItemsAlmacen.length > 0
          ? (
            <div>
              <p style={{ textAlign: 'right', }}>Total: ${this.number_format(cantidadTotal, 2)}</p>

              <p
                className={'modalsVentas__btnAddProducto'}
                onClick={() => { this.onRegisterEntradaAlmacen() }}
              >Registrar entrada</p>
            </div>
          ) : null
        }

        <hr />

        {
          arrayListProductos.length > 0 ? (
            <Row style={{ marginTop: 20, }}>
              <Col xs={'4'} style={{ cursor: 'pointer', }}
                onClick={ () => { this.setBindProductos() }}
                >
                <p>Elige un producto para agregar a la lista</p>
              </Col>
              <Col xs={'6'}>
                <input
                  type="text"
                  id={'ws-input-search-code'}
                  autoComplete="off"
                  placeholder="Ingresa el código del producto..."
                  value={this.state.valSearchByFullCode}
                  onChange={(e) => { this.setState({ valSearchByFullCode: e.target.value }) } }
                  onKeyDown={this._handleKeyDown}
                  ref={(input) => { this.inputSearchByCode = input;  }}
                  style={{ margin: '20px auto', marginTop: 0, width: '100%', background: '#f3f3f3', border: '1px solid #ccc', borderRadius: 4, }}
                />
              </Col>
            </Row>
          ) : null
        }

      </>
    )
  }

  _handleKeyDown(e) {
    if(e.key === 'Enter') {
      this.onSearchProductoByCode()
    }
  }

  onSearchProductoByCode() {
    let { valSearchByFullCode, } = this.state
    let { arrListVenta, arrayListProductos, arrItemsAlmacen, } = this.props.subState

    if(valSearchByFullCode.trim() == '')
      return false

    let countLimit = 0
    let index = -1

    for(var a in arrayListProductos) {
      if(arrayListProductos[a].folio == valSearchByFullCode) {
        index = a
        break;
      }
    }

    if(index > -1) {
      let codigo = '', producto = ''
      let t = arrayListProductos[index]

      if( t.nombre.indexOf(' - ') !== -1) {
        //Tiene código (separar)
        const sep = t.nombre.split(' - ')
        codigo = sep[0]
        producto = sep[1]
      } else
        producto = t.nombre;

      let newItem = [{
        id_producto: t.id_producto,
        codigo,
        producto,
        cantidad: '',
        cortesia: '',
        costo: '',
      }]

      arrItemsAlmacen = [ ...arrItemsAlmacen, ...newItem ]

      this.props.subSetState({ arrItemsAlmacen, })
      this.setState({valSearchByFullCode: '',})

      setTimeout(() => {
        const index0 = arrItemsAlmacen.length - 1
        this[`inputAlmacenNew${(index0)}`].focus();
      }, 100)
    }

  }

  selectItemProduct(e) {
    let { arrItemsAlmacen, arrayListResults } = this.props.subState
    const t = arrayListResults[e]
    let codigo = '', producto = ''

    if( t.nombre.indexOf(' - ') !== -1) {
      //Tiene código (separar)
      const sep = t.nombre.split(' - ')
      codigo = sep[0]
      producto = sep[1]
    } else
      producto = t.nombre;

    let newItem = [{
      id_producto: t.id_producto,
      codigo,
      producto,
      cantidad: '',
      cortesia: '',
      costo: '',
    }]

    arrItemsAlmacen = [ ...arrItemsAlmacen, ...newItem ]

    this.props.subSetState({
      arrItemsAlmacen,
      isOpenSearchProducto: false,
      valSearch: '',
    })

    setTimeout(() => {
      const index = arrItemsAlmacen.length - 1
      // this[`inputVentaID${(index)}`].focus();
    }, 100)

  }

  setBindProductos() {
    this.props.subSetState({ isOpenSearchProducto: true })
  }

  onRegisterEntradaAlmacen() {
    let { signedIn, id_vendedor, id_sucursal, } = this.props.initState
    const { arrItemsAlmacen, fecha_entrada_almacen, serie_almacen, referencia_almacen, } = this.props.subState
    const { mostrarMisVentas, id_sucursal_destino, } = this.state

    //Validamos que todos los items ya tengan cantidad y costo
    let flag = true
    for(var a in arrItemsAlmacen) {
      if(arrItemsAlmacen[a].cantidad == '' || arrItemsAlmacen[a].costo == '') {
        flag = false;
      }

      if( a == (arrItemsAlmacen.length - 1) ) {
        
        //Registramos la entrada en la BD
        if(!flag || serie_almacen == '' || referencia_almacen == '' ) {
          alert('Por favor, registra la cantidad y el costo de cada producto.')
          return false
        } else {

          // Validamos si es el usuario de Araceli, el único que puede cargar productos al almacen gral
          if(signedIn.type === 5) {

            if(id_sucursal_destino === '') {
              alert('Por favor, registra la cantidad y el costo de cada producto.')
              return false
            } else
            id_sucursal = id_sucursal_destino

          } 

          const data = {
            id_vendedor,
            id_sucursal,
            arrItemsAlmacen,
            fecha_entrada_almacen,
            serie_almacen,
            referencia_almacen,
          }

          if (window.confirm(`¿Estás seguro que deseas registrar esta entrada?`)) {
            fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setRegisterEntradaAlmacen", this.headersPOST({...data}))
            .then(response => response.json())
            .then((response) => {
              this.props.subSetState({
                noDocEntradaAlmacen: response.noDocEntradaAlmacen,
                arrItemsAlmacen: [],
                fecha_entrada_almacen: moment().format('YYYY-MM-DD'),
                serie_almacen: '',
                referencia_almacen: '',
              })

              alert('¡Entrada registrada con éxito!')
              this.setState({ mostrarMisVentas: !mostrarMisVentas, })

              this.getStockAlmacen()

            }).catch((error) => console.info(error));
          }

        }
      }
    }
    return false
  }

  getStockAlmacen() {
    const { dateAlmacen, viewTypeFrom, } = this.state
    const { id_sucursal } = this.props.initState

    if(viewTypeFrom === 'meta') {
      fetch("https://hg.wsoft.com.mx/REST/controllers/controllerPreproduction.php?opt=getStockAlmacen2", this.headersPOST({ id_sucursal, dateAlmacen }))
      .then(response => response.json())
      .then((response) => {
        this.setState({arrStockMeta: response, arrStock: [],})
      })
    } else {
      fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getStockAlmacen", this.headersPOST({ id_sucursal, dateAlmacen }))
      .then(response => response.json())
      .then((response) => {
        this.setState({arrStockMeta: [], arrStock: response})
      })
    }
  }

  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }


}

export default withRouter(AltasModulePage)





